import React, { createContext, useContext, useMemo, useState } from 'react'

export const SPONSOR_LEVELS = [
  { value: 'PLATINUM', label: 'Platinum' },
  { value: 'GOLD', label: 'Gold' },
  { value: 'SILVER', label: 'Silver' },
  { value: 'BRONZE', label: 'Bronze' },
  { value: 'SOCIETY', label: 'Society' },
]

const SponsorLevelContext = createContext()
export const useSponsorLevelContext = () => useContext(SponsorLevelContext)

export const QASponsorLevelProvider = ({ children }) => {
  const [level, setLevel] = useState(null)

  const value = useMemo(() => ({ setLevel, level }), [level])
  return <SponsorLevelContext.Provider value={value}>{children}</SponsorLevelContext.Provider>
}
